export class NavigationCall {
    static constructFromPlainObject(plainObject) {
        return new NavigationCall(plainObject.app, plainObject.pathParam, plainObject.queryParams);
    }
    constructor(app, pathParam, queryParams) {
        this.app = app;
        this.pathParam = pathParam || '';
        this.queryParams = queryParams || {};
    }
    getApp() {
        return this.app;
    }
    getPathParam() {
        return this.pathParam;
    }
    getQueryParams() {
        return this.queryParams;
    }
}
//# sourceMappingURL=navigationCall.js.map